import userService from '../../../services/userService';
import { User } from '../domain/User';
import { persistStoredUser } from './userStorage';

export function loadUserProfile(user: User): Promise<void> {
  return userService
    .getProfile(user.userId)
    .then((response: { profile?: { imageUrl?: string }; accountIds?: User['accountIds'] }) => {
      user.profileImageUrl = response?.profile?.imageUrl;
      if (response && Array.isArray(response.accountIds)) {
        user.accountIds = response.accountIds;
      }
      persistStoredUser(user);
    });
}
